import { UpdateAssetFormState } from "@/admin/asset/update/form/UpdateAssetForm"
import { UpdateAssetFormFieldsFragment$key } from "@/admin/asset/update/form/__generated__/UpdateAssetFormFieldsFragment.graphql"
import { UpdateAssetFormMutation } from "@/admin/asset/update/form/__generated__/UpdateAssetFormMutation.graphql"
import FormStore from "@/core/form/store/FormStore"
import makeUseStyles from "@assets/style/util/makeUseStyles"
import CoverPhoto from "@components/cover-photo/CoverPhoto"
import { DiscoFormControl, DiscoInput } from "@disco-ui"
import DiscoVideo from "@disco-ui/video/DiscoVideo"
import { observer } from "mobx-react-lite"
import { useFragment } from "react-relay"
import { graphql } from "relay-runtime"

interface Props {
  form: FormStore<UpdateAssetFormState, UpdateAssetFormMutation>
  assetKey: UpdateAssetFormFieldsFragment$key
}

function UpdateAssetFormFields(props: Props) {
  const { form, assetKey } = props
  const classes = useStyles()

  const asset = useFragment<UpdateAssetFormFieldsFragment$key>(
    graphql`
      fragment UpdateAssetFormFieldsFragment on Asset {
        url
        fileType
        ...DiscoVideoFragment
      }
    `,
    assetKey
  )

  return (
    <>
      {asset.fileType === "image" ? (
        <CoverPhoto customClassName={classes.preview} coverPhoto={asset.url} />
      ) : asset.fileType === "video" ? (
        <DiscoVideo
          radius={"medium"}
          src={asset.url}
          assetKey={asset}
          className={classes.preview}
          playButton={{ size: "small" }}
        />
      ) : null}
      <DiscoFormControl label={"Asset Name"}>
        <DiscoInput
          value={form.state.name}
          onChange={(e) => (form.state.name = e.target.value)}
          data-testid={"UpdateAssetFormFields.name"}
        />
      </DiscoFormControl>
    </>
  )
}

const useStyles = makeUseStyles((theme) => ({
  preview: {
    marginBottom: theme.spacing(1.5),
  },
}))

export default observer(UpdateAssetFormFields)
